import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import LoginBox from './../../components/LoginBox/LoginBox';
import { ToastContainer, toast } from 'react-toastify';

const LoginPage = (props) => {

  let {history, location} = props;

  //let location = useLocation();
  let navigate = useNavigate();

  return (
    <div>
      <LoginBox history={navigate} />
      <ToastContainer enableMultiContainer position="bottom-right" />
    </div>
  )
}

export default LoginPage;